import React, {Component} from "react";  import config from 'react-global-configuration';

class Page404 extends Component {
    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row top10">
                        <div className="col-lg-12 col-sm-12">
                            <div className="col-md-12 notfoundContainer">
                                <div className="col-md-12">
                                    <h2>Page not found</h2>
                                    <div>We're sorry, we couldn't find the page you requested.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Page404;
